import type { Cart } from '@src/domains/cart/types/cart';

export const hasCheckoutableItems = (input: { cart?: Cart; couponErrors?: string[] }): boolean => {
  const cartItems = input.cart?.items ?? [];

  return Boolean(input.cart && cartItems.length > 0 && input.couponErrors?.length === 0);
};
